import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ReactiveState___init__impl__fvdp9b(raw) {
  return raw;
}
function _ReactiveState___get_raw__impl__92ipya($this) {
  return $this;
}
function ReactiveState__get_impl_reoidr($this) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya($this);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    throw NotReadyException().hao();
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      throw _ReactiveState___get_raw__impl__92ipya($this).uah_1;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya($this).tah_1;
        tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      } else {
        tmp = _ReactiveState___get_raw__impl__92ipya($this);
      }
    }
  }
  return tmp;
}
function ReactiveState__getOrNull_impl_1asnfp($this) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya($this);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      _ReactiveState___get_raw__impl__92ipya($this).uah_1;
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        var tmp_0 = _ReactiveState___get_raw__impl__92ipya($this).tah_1;
        tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      } else {
        tmp = _ReactiveState___get_raw__impl__92ipya($this);
      }
    }
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = _ReactiveState___init__impl__fvdp9b(InternalReactiveNotReady_instance);
        tmp.oah_1 = new (ReactiveState())(tmp_0) instanceof ReactiveState() ? tmp_0 : THROW_CCE();
      }
      wah(exception) {
        var tmp;
        if (exception instanceof CancellationException()) {
          tmp = this.oah_1;
        } else {
          tmp = _ReactiveState___init__impl__fvdp9b(new (InternalReactiveThrownException())(exception));
        }
        var tmp_0 = tmp;
        return new (ReactiveState())(tmp_0) instanceof ReactiveState() ? tmp_0 : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function ReactiveState__toString_impl_65vhu1($this) {
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya($this);
  var tmp;
  if (tmp0_subject instanceof InternalReactiveNotReady()) {
    tmp = 'NotReady';
  } else {
    if (tmp0_subject instanceof InternalReactiveThrownException()) {
      tmp = 'ThrownException(' + _ReactiveState___get_raw__impl__92ipya($this).uah_1.toString() + ')';
    } else {
      if (tmp0_subject instanceof InternalReactiveWrapper()) {
        tmp = 'ReadyW(' + toString(_ReactiveState___get_raw__impl__92ipya($this)) + ')';
      } else {
        tmp = 'Ready(' + toString_0(_ReactiveState___get_raw__impl__92ipya($this)) + ')';
      }
    }
  }
  return tmp;
}
function ReactiveState__hashCode_impl_flaeyu($this) {
  return $this == null ? 0 : hashCode($this);
}
function ReactiveState__equals_impl_lyar8q($this, other) {
  if (!(other instanceof ReactiveState()))
    return false;
  var tmp0_other_with_cast = other.iao_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ReactiveStateClass;
function ReactiveState() {
  if (ReactiveStateClass === VOID) {
    class $ {
      constructor(raw) {
        Companion_getInstance();
        this.iao_1 = raw;
      }
      toString() {
        return ReactiveState__toString_impl_65vhu1(this.iao_1);
      }
      hashCode() {
        return ReactiveState__hashCode_impl_flaeyu(this.iao_1);
      }
      equals(other) {
        return ReactiveState__equals_impl_lyar8q(this.iao_1, other);
      }
    }
    initMetadataForClass($, 'ReactiveState');
    ReactiveStateClass = $;
  }
  return ReactiveStateClass;
}
var InternalReactiveNotReadyClass;
function InternalReactiveNotReady() {
  if (InternalReactiveNotReadyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'InternalReactiveNotReady');
    InternalReactiveNotReadyClass = $;
  }
  return InternalReactiveNotReadyClass;
}
var InternalReactiveNotReady_instance;
function InternalReactiveNotReady_getInstance() {
  return InternalReactiveNotReady_instance;
}
var InternalReactiveThrownExceptionClass;
function InternalReactiveThrownException() {
  if (InternalReactiveThrownExceptionClass === VOID) {
    class $ {
      constructor(exception) {
        this.uah_1 = exception;
      }
      toString() {
        return 'InternalReactiveThrownException(exception=' + this.uah_1.toString() + ')';
      }
      hashCode() {
        return hashCode(this.uah_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InternalReactiveThrownException()))
          return false;
        if (!equals(this.uah_1, other.uah_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'InternalReactiveThrownException');
    InternalReactiveThrownExceptionClass = $;
  }
  return InternalReactiveThrownExceptionClass;
}
var NotReadyExceptionClass;
function NotReadyException() {
  if (NotReadyExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static hao(message) {
        message = message === VOID ? null : message;
        var $this = this.o4(message);
        captureStack($this, $this.gao_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NotReadyException', $.hao);
    NotReadyExceptionClass = $;
  }
  return NotReadyExceptionClass;
}
var InternalReactiveWrapperClass;
function InternalReactiveWrapper() {
  if (InternalReactiveWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'InternalReactiveWrapper');
    InternalReactiveWrapperClass = $;
  }
  return InternalReactiveWrapperClass;
}
//region block: init
InternalReactiveNotReady_instance = new (InternalReactiveNotReady())();
//endregion
//region block: exports
export {
  InternalReactiveNotReady as InternalReactiveNotReadygki7zhqkkp9u,
  InternalReactiveThrownException as InternalReactiveThrownException1wn4fe03qbefg,
  InternalReactiveWrapper as InternalReactiveWrapper6qytbrc1rcqv,
  ReactiveState as ReactiveStatel8ixobo86msn,
  _ReactiveState___init__impl__fvdp9b as _ReactiveState___init__impl__fvdp9b2eqyidpf491cp,
  ReactiveState__getOrNull_impl_1asnfp as ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq,
  ReactiveState__get_impl_reoidr as ReactiveState__get_impl_reoidr323siyisyfdmv,
  _ReactiveState___get_raw__impl__92ipya as _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0,
  ReactiveState__toString_impl_65vhu1 as ReactiveState__toString_impl_65vhu1175m9ejx57nas,
  InternalReactiveNotReady_instance as InternalReactiveNotReady_instance37iasaqvolrrz,
  Companion_getInstance as Companion_getInstance1a6q7ejsqzzhs,
};
//endregion

//# sourceMappingURL=ReactiveState.mjs.map
